module.exports = __webpack_public_path__ + "static/img/iso3.d4acf41b.png";